'use client';
import { useEffect } from 'react';

export interface TemplateProps {
  children: React.ReactNode;
}

const FoucTemplate: React.FC<TemplateProps> = ({ children }) => {
  useEffect(() => {
    const foucWrapper = window.document.getElementById('fouc-wrapper');

    if (foucWrapper) {
      foucWrapper.style.opacity = '1';
    }
  }, []);

  return (
    <div id="fouc-wrapper" style={{ opacity: 0 }}>
      {children}
    </div>
  );
};

export default FoucTemplate;
